module.exports = __webpack_public_path__ + "cb66085f07bb8e58140878e8c903f100.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint.jpg
// module id = 811
// module chunks = 0